const { cxt } = require('./context');

/**
 * Validates product
 * @type {Array<cxt>}
 * @memberof validators
 */
const loanAmount = [
  cxt('min'),
  cxt('max'),
];

module.exports = {
  loanAmount,
};
